import { render, staticRenderFns } from "./Competition.vue?vue&type=template&id=f14c38f6&scoped=true&"
import script from "./Competition.vue?vue&type=script&lang=ts&"
export * from "./Competition.vue?vue&type=script&lang=ts&"
import style0 from "./Competition.vue?vue&type=style&index=0&id=f14c38f6&scoped=true&lang=css&"
import style1 from "./Competition.vue?vue&type=style&index=1&id=f14c38f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14c38f6",
  null
  
)

export default component.exports